export default hilighted => hilighted && hilighted.classed('-hilight', false)



// WEBPACK FOOTER //
// ./src/components/munis-map/unhilight_path.js